import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  posterImage: belongsTo('asset', { inverse: null }),
});
